import { AmountWithIcon } from "@/components/AmountWithIcon";
import { Icon } from "@/components/Icon";
import { PaymentIcons } from "@/components/PaymentIcons";
import { renderOperateType, renderStatus } from "@/constants/order/key";
import { PendingOrder } from "@/types/Api/Market/PendingOrder/myPendingOrderDetail";
import { amountFormat } from "@/utils/tool";
import { Space } from "antd-mobile";
import styles from "./index.module.scss";
export const ListItem = ({
  item,
  onClick
}: {
  item: PendingOrder;
  onClick: (item: PendingOrder) => void;
}) => <div className={styles.listItem} onClick={() => onClick(item)} data-sentry-component="ListItem" data-sentry-source-file="index.tsx">
    <div className={styles.listItemDate}>
      {(item.createTime || "").split(" ").map((item: string) => <div key={item}>{item}</div>)}
    </div>

    <div>
      <div>{renderOperateType(item.isSplit, item, "拆分")}</div>
      <div>
        <PaymentIcons payments={item.paymentType} data-sentry-element="PaymentIcons" data-sentry-source-file="index.tsx" />
      </div>
    </div>
    <div>
      <AmountWithIcon amount={amountFormat(item.validAmount, {
      places: 2
    })} className={styles.listItemAmount} data-sentry-element="AmountWithIcon" data-sentry-source-file="index.tsx" />
    </div>
    <div>
      <Space data-sentry-element="Space" data-sentry-source-file="index.tsx">
        {renderStatus(item.status, item)}
        <span>
          <Icon name={"operate_arrow_right"} size="16px" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
        </span>
      </Space>
    </div>
  </div>;